import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { IForm, IFormViewer } from '@fi-shared/fi-form-shared/fi-form-shared';
import { AppTextService } from '@fi-shared/app-text';
import { isDefined } from '@fi-shared/utils';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiSignalRHelperService } from '@fi-shared/fi-signal-r/fi-signal-r-helper.service';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Injectable()
export class FiFormSharedService {
    constructor(
        private fiBackend: FiBackendService,
        private loadingService: LoadingService,
        private appText: AppTextService,
        private fiSignalRHelperService: FiSignalRHelperService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    getFormViewer(formId: number | string, answerSetId?: number) {
        return this.loadingService.trackPromise(
            this.fiBackend.fetchData<IFormViewer>(
                `Form/Form/GetFormViewer/${formId}${answerSetId ? '/' + answerSetId : ''}`,
            ),
        );
    }

    getFormViewerForPreview(form: IForm) {
        return this.loadingService.trackPromise(
            this.fiBackend.fetchDataPost<IFormViewer>(`Form/Form/GetFormViewerForPreview`, form),
        );
    }

    saveFormViewer(formViewer: IFormViewer, businessUnitId: number) {
        let url = `Form/Form/SaveFormViewer`;
        if (isDefined(businessUnitId)) {
            url += `?businessUnitId=${businessUnitId}`;
        }
        return this.fiBackend.fetchDataPost(url, formViewer);
    }

    getFormsForWidget() {
        return this.fiBackend.fetchData<IForm[]>(`Form/Form/GetFormsForWidget`);
    }

    /* returns new ReminderSent date (ISO 8601 Date)
     */
    sendFormReminders(formId: number, userIds: number[]) {
        return this.fiBackend.fetchDataPost<string>(`Form/Form/SendFormReminders/${formId}`, userIds);
    }

    getFormEndDateTextForWidget(form: IForm) {
        if (form.EndDate) {
            return this.appText.get('common.ends') + ' ' + this.fiFormatDateService.formatDate(form.EndDate, 'date');
        }
        return this.appText.get('form.continuous_sharing');
    }

    isFormUnSeen(formId: number) {
        return this.fiSignalRHelperService.newFormIds$.value.indexOf(formId) !== -1;
    }

    deleteFormAnswers(formIds: number[]) {
        return this.loadingService.trackPromise(
            this.fiBackend.fetchDataPost<void>('Form/Form/DeleteFormAnswers', formIds),
        );
    }

    markFormAsVisited(formId: number) {
        return this.fiBackend.fetchDataPost('Form/Form/MarkFormAsVisited/' + formId);
    }

    markFormAnswerSetsAsVisited(answerSetIds: number[]) {
        return this.fiBackend.fetchDataPost('Form/FormReport/MarkFormAnswerSetsAsVisited', answerSetIds);
    }
}
